module.exports = __webpack_public_path__ + "static/media/logo-rotas.27c0f35b.svg";